import React, { Component } from 'react';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';

// import Pagination from 'components/Pagination/Pagination';
import Spinner from 'components/Spinner';
import withReportingAnalytics from 'decorators/withReportingAnalytics';
import UsersAnalytics from 'components/AnalyticsTables/UsersAnalytics';
import SubscriptionsAnalytics from 'components/AnalyticsTables/SubscriptionsAnalytics';
import PlansAnalytics from 'components/AnalyticsTables/PlansAnalytics';

class ViewAnalytics extends Component {
  render() {
    const {
      usersAnalyticsLoading,
      subscriptionsAnalyticsLoading,
      plansAnalyticsLoading,
      usersAnalytics,
      subscriptionsAnalytics,
      plansAnalytics,
      isAdminOrManager,
      loggedInUser,
    } = this.props;

    if (loggedInUser && !isAdminOrManager) {
      return <Redirect to="/" />;
    }

    const showLoader =
      usersAnalyticsLoading ||
      subscriptionsAnalyticsLoading ||
      plansAnalyticsLoading;

    return (
      <div className="relative">
        <h1 className="mar-b">Internal Metrics</h1>
        <div>
          <h2 className="flex-justify-center" style={{ margin: '20px 0 30px' }}>
            Plans
          </h2>
          <PlansAnalytics plansAnalytics={plansAnalytics} />
        </div>
        <div className="mar-t">
          <h2 className="flex-justify-center" style={{ margin: '70px 0 30px' }}>
            Subscriptions
          </h2>
          <SubscriptionsAnalytics
            subscriptionsAnalytics={subscriptionsAnalytics}
          />
        </div>
        <div className="mar-t">
          <h2 className="flex-justify-center" style={{ margin: '70px 0 30px' }}>
            Users
          </h2>
          <UsersAnalytics usersAnalytics={usersAnalytics} />
        </div>
        <Spinner showLoader={showLoader} />
      </div>
    );
  }
}

export default compose(withReportingAnalytics)(ViewAnalytics);
